import React, { useState } from "react";
import axios from "axios";
import { Col, Container, Form, Row } from "reactstrap";
import "./scss/contact.scss";

const Contact = () => {
  const [formData, setFormData] = useState({
    nombre: "",
    email: "",
    telefono: "",
    asunto: "",
    mensaje: "",
  });
  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validación básica
    if (!formData.nombre || !formData.email || !formData.mensaje) {
      setError("Por favor completa los campos obligatorios.");
      return;
    }

    try {
      setSending(true);
      setError("");
      await axios.post("/api/send", formData);
      setSuccess(true);
      setFormData({
        nombre: "",
        email: "",
        telefono: "",
        asunto: "",
        mensaje: "",
      });
    } catch (err) {
      setError("Ocurrió un error al enviar el mensaje.");
    } finally {
      setSending(false);
    }
  };

  return (
    <section id="contact" className="contact-wrapper">
      <Container>
        <Row className="contact-box aesthetic-shadow rounded-4">
          <Col md={6} className="contact-content">
            <h6 className="section-subtitle">Contáctanos</h6>
            <h3 className="section-title">
              ¡No pierdas tiempo con la contabilidad!
            </h3>
            <p className="section-desc">
              En BackApp Chile te ayudamos a ordenar tu negocio y enfocarte en lo
              importante. Escríbenos y te ayudamos desde ya con una asesoría
              personalizada.
            </p>

            <div className="contact-detail">
              <i className="bi bi-envelope-fill" />
              <span>soporte@backappchile.com</span>
            </div>

            <div className="contact-detail">
              <i className="bi bi-whatsapp" />
              <span>+56 9 5520 6807</span>
            </div>
          </Col>

          <Col md={6}>
            <Form className="contact-form" onSubmit={handleSubmit}>
              <input
                type="text"
                name="nombre"
                placeholder="Tu nombre"
                value={formData.nombre}
                onChange={handleChange}
              />
              <input
                type="email"
                name="email"
                placeholder="Tu email"
                value={formData.email}
                onChange={handleChange}
              />
              <div className="phone-input">
                <span className="prefix">+56&nbsp;9</span>
                <input
                  type="tel"
                  id="telefono"
                  name="telefono"
                  className="form-control"
                  placeholder="Tu número de teléfono"
                  maxLength="9"
                  value={formData.telefono}
                  onChange={handleChange}
                />
              </div>
              <input
                type="text"
                name="asunto"
                placeholder="Asunto"
                value={formData.asunto}
                onChange={handleChange}
              />
              <textarea
                name="mensaje"
                rows="4"
                placeholder="Mensaje"
                value={formData.mensaje}
                onChange={handleChange}
              />

              {success && (
                <p className="text-success mt-3">
                  Mensaje enviado correctamente
                </p>
              )}
              {error && <p className="text-danger mt-3">{error}</p>}

              <div className="text-end">
                <button type="submit" className="btn-aesthetic">
                  Enviar mensaje
                </button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Contact;
